import { SensolusDatetimeReact } from "@/constants/Config";

interface SntDateViewProps {
  value?: string | null;
  other?: string;
  format?: string;
}

const SntDateView = ({ value, other, format }: SntDateViewProps) => {
  const rs = value
    ? format
      ? SensolusDatetimeReact.parse(value, "server").format(format)
      : SensolusDatetimeReact.fromNow(
          SensolusDatetimeReact.parse(value, "server")
        )
    : other
    ? other
    : "";

  return <span title={rs}>{rs}</span>;
};
export default SntDateView;
